export default __webpack_public_path__ + "static/media/blackboard-css.46724b84.jpeg";